<template>
    <div class="main">
        <!--Filter-->
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form ref="formularioValido" class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTNombre" label="Nombre" v-on:keyup.enter="loadData" clearable outlined dense></v-text-field>
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTTitulo" label="Titulo" v-on:keyup.enter="loadData" outlined clearable dense></v-text-field>
                        <v-autocomplete class="pr-2 mx-240" v-model="filter.fkNTipoAgrupacionElemento" :items="elementsGroupsTypes" item-text="fldTNombre" item-value="idNTipoAgrupacionElemento" 
                                        label="Tipo Agrupacion Elemento" v-on:keyup.enter="loadData" outlined clearable dense></v-autocomplete>
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldNOrden" type="number" :min="0" label="Orden" @keypress="OrdenKeyPress($event)" v-on:keyup.enter="loadData" 
                                      outlined clearable dense></v-text-field>
                        <v-card-actions class="btns-float">
                            <v-btn color="grey" @click="clearFilter" small>Limpiar</v-btn>
                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>
        <!--Buttons-->
        <v-container class="pb-3 ml-1 mb-3">
            <v-btn color="accent" small dark @click="addGroupElement">Agregar Tipo Agrupacion Elemento </v-btn>
            <v-btn small color="accent" dark class="ml-5" @click="exportPDF">
                PDF <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
            <v-btn small color="accent" class="ml-5" dark @click="exportExcel">
                Excel <v-icon dark right>mdi-file-excel-outline</v-icon>
            </v-btn>

        </v-container>
        <!--NewForm-->
        <v-dialog persistent v-model="nuevoForm" max-width="500">
            <v-card class="mx-auto">
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>Agregar Tipo Agrupación Elemento</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form ref="formularioNuevo" class="slim">
                    <v-container class="d-flex pt-6 flex-row flex-wrap">
                        <v-text-field class="pr-3 mx-240" v-model="groupElement.fldTNombre" label="Nombre" :rules="nombreRule" outlined dense></v-text-field>
                        <v-autocomplete class="pr-3 mx-240" v-model="groupElement.fkNTipoAgrupacionElemento" :items="elementsGroupsTypes" item-text="fldTNombre" 
                                        item-value="idNTipoAgrupacionElemento" label="Tipo Agrupacion Elemento" :rules="tipoRule" clearable outlined dense></v-autocomplete>
                        <v-text-field class="pr-3 mx-240" v-model="groupElement.fldTTitulo" label="Titulo" :rules="tituloRule"  outlined dense></v-text-field>
                        <v-text-field class="pr-3 mx-240" v-model="groupElement.fldNOrden" type="number" :rules="ordenRule" :min="0" label="Orden" @keypress="OrdenKeyPress($event)" 
                                      outlined clearable dense></v-text-field>
                        <v-card-actions class="btns-float pt-6 pb-6">
                            <v-btn text small @click="nuevoForm = false">
                                cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="saveData">
                                Guardar cambios
                            </v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>

            </v-card>
        </v-dialog>
        <!--Edit Form-->
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="editForm" max-width="500">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Editar Agrupacion Elemento</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-form ref="formularioEdicion" class="slim">
                            <v-container class="d-flex pt-6 flex-row flex-wrap ">
                                <v-text-field class="pr-3 mx-240" v-model="groupElement.fldTNombre" label="Nombre" :rules="nombreRule" 
                                              outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                <v-autocomplete class="pr-3 mx-240" v-model="groupElement.fkNTipoAgrupacionElemento" :rules="tipoRule" :items="elementsGroupsTypes" 
                                                item-text="fldTNombre" item-value="idNTipoAgrupacionElemento" label="Tipo Agrupacion Elemento" 
                                                clearable outlined dense :disabled="puedeCambiar == false"></v-autocomplete>
                                <v-text-field class="pr-3 mx-240" v-model="groupElement.fldTTitulo" label="Titulo" :rules="tituloRule" 
                                              outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                <v-text-field class="pr-3 mx-240" v-model="groupElement.fldNOrden" type="number" :rules="ordenRule" :min="0" label="Orden" @keypress="OrdenKeyPress($event)" 
                                              outlined clearable dense :disabled="puedeCambiar == false"></v-text-field>

                                <v-card-actions class="justify-space-between w-100 pt-3 pb-6">
                                    <v-btn class="ma-2" dark small color="red" @click="deleteItem">
                                        <v-icon left>mdi-delete</v-icon> Borrar registro
                                    </v-btn>
                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                            Cancelar
                                        </v-btn>
                                        <v-btn v-if="puedeCambiar == false" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                            <v-icon left>mdi-pencil</v-icon> Editar
                                        </v-btn>
                                        <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                            <v-icon left>mdi-pencil</v-icon> Guardar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <!--Table-->
        <v-container fluid class="pt-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <template>
                            <v-data-table dense :headers="headers" :items="elementsGroups" item-key="idNAgrupacionElemento" :footer-props="{
    'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                                <template v-slot:item.ico1="{ item }">
                                    <v-chip :color="item.ico1" dark label></v-chip>
                                </template>
                                <template v-slot:item.fkNTipoAgrupacionElemento="{item}">
                                    {{getGroupElementTypeDescription(item.fkNTipoAgrupacionElemento)}}
                                </template>

                                <template v-slot:item.ico2="{ item }">
                                    <v-btn text icon @click.stop="dialog = true">
                                        <v-icon color="blue">mdi-file-document-box</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:item.action="{ item }">
                                    <v-icon color="green" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <confirm ref="confirmDialog">
        </confirm>
    </div>
</template>

<script>
    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";

    // Services
    import GroupElementService from '../services/GroupElementService';
    import GroupElementTypeService from '../services/GroupElementTypeService';

    // Models
    import GroupElementModel from '../models/GroupElementModel';
    import jsPDF from 'jspdf';

    import 'jspdf-autotable';
    import Confirm from '../components/ConfirmDelete';
    import ImageSelector from '@/components/ImageSelector';
    import { isNumericKey } from '../common/isNumericKey.js';

    @Component({
        components: {
            Confirm,
            ImageSelector
        },
        mounted: async function () {
            await this.loadData();
        },
        computed: {
        },
        methods: {

            // Keypress para chequear input Orden

            OrdenKeyPress(e) {
                isNumericKey(e);
            },
            
            loadData: async function () {
                try {
                    var resGE = await new GroupElementService().list(this.filter);
                    if (resGE.success) {
                        this.$data.elementsGroups = resGE.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resGE.Message);
                    }  

                    var resGET = await new GroupElementTypeService().list({});
                    if (resGET.success) {
                        this.$data.elementsGroupsTypes = resGET.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resGET.Message);
                    }

                } catch (e) {
                    console.log(e);
                }
            },

            clearFilter: function () {
                this.$data.filter = new GroupElementModel();
                this.loadData();
            },

            addGroupElement: function () {
                this.$data.groupElement = new GroupElementModel();
                this.$data.nuevoForm = true;
            },

            chkBotonCancelar() {
                // Estoy editando y presiono cancelar
                if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                    this.$data.groupElement = JSON.parse(JSON.stringify(this.$data.groupElementAux));
                    this.$data.puedeCambiar = false;
                } else {
                    this.closeDialog();
                }
            },
            saveData: async function () {
                try {

                    if (this.$refs.formularioNuevo != null) {
                        if (!this.$refs.formularioNuevo.validate()) {
                            return;
                        }
                    }

                    if (this.$refs.formularioEdicion != null) {
                        if (!this.$refs.formularioEdicion.validate()) {
                            return;
                        }
                    }

                    var uService = new GroupElementService(this.filter);
                    var data = null;
                    if (this.$data.groupElement.idNAgrupacionElemento) {
                        data = await uService.update(this.$data.groupElement);
                    } else {
                        data = await uService.insert(this.$data.groupElement);
                    }
                    
                    if (data.success) {
                        this.nuevoForm = false;
                        this.closeDialog();
                        this.loadData();
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                    }
                } catch (e) {
                    console.log(e);
                }
            },

            getGroupElementTypeDescription(id) {
                let desc = this.$data.elementsGroupsTypes.find(function (e) {
                    return e.idNTipoAgrupacionElemento == id;
                });
                if (desc)
                    return desc.fldTNombre;
                return id;
            },

            closeDialog() {
                this.editForm = false;
                this.puedeCambiar = false;
                this.alert = false;
                this.$data.groupElement = new GroupElementModel();
                this.$data.groupElementAux = new GroupElementModel();
            },

            editItem(item) {
                this.$data.groupElement = JSON.parse(JSON.stringify(item));
                this.$data.groupElementAux = JSON.parse(JSON.stringify(item));
                this.$data.editForm = true;
            },

            async deleteItem() {
                var ret = await this.$refs.confirmDialog.showDialog();
                if (ret == true) {
                    var data = await new GroupElementService().delete(this.$data.groupElement);
                    if (data.success) {
                        this.showSuccess('El registro fue eliminado correctamente');
                        this.loadData();
                    } else {
                        this.showError('Ocurrio un error borrando el registro: ' + data.error);
                    }
                }
                this.closeDialog();
            },

            async exportExcel() {
                var data = await new GroupElementService().export(this.filter);
                var fileURL = window.URL.createObjectURL(data);
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'AgrupacionesElementos.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            },

            //VER
            exportPDF() {
                var doc = new jsPDF({ orientation: 'landscape' });
                var title = 'Agrupaciones Elementos';
                var columns = [
                    { title: 'Nombre', dataKey: 'fldTNombre' },
                    { title: 'Titulo', dataKey: 'fldTTitulo' },
                    { title: 'Tipo Agrupacion Elemento', dataKey: 'fkNTipoAgrupacionElemento' },
                    { title: 'N° Orden', dataKey: 'fldNOrden' },
                ];
                // Customizar columnas
                doc.text(title, 15, 15);
                var self = this;
                var data = JSON.parse(JSON.stringify(this.$data.elementsGroups));
                data.forEach(function (d) {
                    d.fkNTipoAgrupacionElemento = self.elementsGroupsTypes.find(x => x.idNTipoAgrupacionElemento == d.fkNTipoAgrupacionElemento).fldTNombre;
                });
                doc.autoTable(columns, data, { margin: { top: 20 }, styles: { cellPadding:0.5,fontSize: 8 } })
                doc.save(title + '.pdf');
            }

        }
    })
    export default class AgrupacionesElementos extends Vue {
        nuevoForm = false;
        editForm = false;
        puedeCambiar = false;
        formularioNuevo = true;
        formularioEdicion = true;
        alert = false;


        // Listas
        elementsGroupsTypes = [];
        elementsGroups = [];

        // Models
        filter = new GroupElementModel();
        groupElement = new GroupElementModel();
        groupElementAux = new GroupElementModel();
        on = true;

        // Reglas de Validacion

        tipoRule = [
            v => v && v > 0 || 'Debe seleccionar un Tipo'
        ];

        ordenRule = [
            v => v && v > 0 || 'Debe ingresar el Orden'
        ];

        nombreRule = [
            v => !!v || 'Debe ingresar un Nombre',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',  
        ];

        tituloRule = [
            v => !!v || 'Debe ingresar un Titulo',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',  
        ];

        

        // Headers de la tabla

        headers = [
            { text: '', value: 'ico1', sortable: false, width:10 },
            { text: '', value: 'action', sorteable: false, width:10 },
            { text: 'Nombre', value: 'fldTNombre' },
            { text: 'Titulo', value: 'fldTTitulo' },
            { text: 'Tipo Agrupacion Elemento', value: 'fkNTipoAgrupacionElemento' },
            { text: 'N° Orden', value: 'fldNOrden' },
        ];
    }
</script>
